import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from './CalculationStatus.module.scss';

export type CalculationStatusType = 'COMPLETED' | 'RUNNING' | 'ERROR' | 'STOPPED' | 'INITIALIZING';

type CalculationStatusProps = {
  status: CalculationStatusType;
  className?: string;
};

const STATUS_CONFIG: Record<CalculationStatusType, { color: string; backgroundColor: string }> = {
  COMPLETED: {
    color: 'rgba(33, 150, 83, 1)',
    backgroundColor: 'rgba(33, 150, 83, 0.2)',
  },
  RUNNING: {
    color: 'rgba(45, 156, 219, 1)',
    backgroundColor: 'rgba(45, 156, 219, 0.3)',
  },
  ERROR: {
    color: 'rgba(235, 87, 87, 1)',
    backgroundColor: 'rgba(235, 87, 87, 0.2)',
  },
  STOPPED: {
    color: 'rgba(242, 153, 74, 1)',
    backgroundColor: 'rgba(242, 153, 74, 0.25)',
  },
  INITIALIZING: {
    color: 'rgba(189, 105, 255, 1)',
    backgroundColor: 'rgba(189, 105, 255, 0.3)',
  },
};

export const CalculationStatus = observer(function CalculationStatus({ status, className }: CalculationStatusProps) {
  const { t } = useTranslation('widgets');

  const config = STATUS_CONFIG[status];
  const label = t(`CalculationStatus.${status}`);
  return (
    <span
      className={`${styles.status} ${className || ''}`}
      style={{
        color: config.color,
        backgroundColor: config.backgroundColor,
      }}
    >
      {label}
    </span>
  );
});
